import { SquareStackIcon } from "lucide-react";
import { Button } from "../../../../../../shared/components/button/Button";

const ObjectivesTrackerDuplicateButton = ({ onClickHandler }) => {
  return (
    <Button
      aria-haspopup="true"
      size="icon"
      variant="ghost"
      onClick={onClickHandler}
    >
      <SquareStackIcon className="h-4 w-4" />
      <span className="sr-only">Toggle menu</span>
    </Button>
  );
};

export default ObjectivesTrackerDuplicateButton;
